export default "__VITE_ASSET__HN32MVbF__"